// extracted by mini-css-extract-plugin
export default {"item-current":"timeline-module__item-current--2uRCg","item-link":"timeline-module__item-link--3u1jx"};